import React, { useState, useEffect } from "react";
import Button from "../../atoms/Button";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import NotificationDialog from "../../molecules/NotificationDialogBox";
import {
  addToWishlist,
  removeFromWishlist
} from "../../../redux/slices/wishlist-slice";
import { addWishlist } from "../../../utils/API/addToWishlist";
import { deleteWishlistItem } from "../../../utils/API/deleteWishlist";
import { useDispatch } from "react-redux";
import { getRegistryImage } from "../../../utils/helper/getRegistryImage";
import toast from "react-hot-toast";

const Index = ({
  actionButton = true,
  _id,
blockchain_detail,
  project: {
    _id: projectId,
    projectName,
     blockchain_detail: projectBlockchainDetail,
    tokenType,
    location: { country, state },
    cover_image,
    ogScore = 90,
    SDG_contribution,
    typeOfCredit,
    categoryDetails: { categoryName },
    subCategoryDetails: { subCategoryName },
    registryDetails: { registryName }
  },
  userData: { userId },
  numberOfCredits = "700 Credits",
  no_of_credits_to_sell = "500",
  projectImage = "/images/projectone.png",
  price_per_credit = "2",
  isListed = true,
  credit_transaction = "Fully",
  bidHandler,
  InquireHandler
}) => {
  const localRegistryImage = getRegistryImage(registryName);
  const [notificationDialogState, setNotificationDialogState] = useState(false);
  const { userType } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const [isWishlistClicked, setIsWishlistClicked] = useState(null);
  const [wishlistUnavailable, setWishlistUnavailable] = useState(false);
  const [userNotFoundDailog, SetUserNOtFoundDailog] = useState(false);

  const wishlist = useSelector((state) => state.wishlist);

  useEffect(() => {
    // console.log("wish", wishlist);
    if (wishlist) {
      const isProjectInWishlist = wishlist.find(
        (item) =>
          item.holdingsId === _id && item.is_enquire_required !== isListed
      );
      setIsWishlistClicked(isProjectInWishlist);
    }
  }, [wishlist, _id]);

  const handleWishlistClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!userType) {
      SetUserNOtFoundDailog(true);
      return;
    }

    if (isWishlistClicked) {
      handleRemoveFromWishlist();
    } else {
      try {
        const additionalParams = { holdingsId: _id, credit_owner: userId };
        if (isListed) {
          additionalParams.is_enquire_required = false;
        } else {
          additionalParams.is_enquire_required = true;
        }
        const result = await addWishlist(additionalParams, dispatch);
        if (result.success) {
          dispatch(addToWishlist(result.data));
          setIsWishlistClicked(result.data);
        } else {
          console.error("Failed to add to wishlist:", result.message);
        }
      } catch (error) {
        console.error("Error adding project to wishlist:", error);
      }
    }
  };
const finalBlockchainDetail = blockchain_detail || projectBlockchainDetail;
  const handleRemoveFromWishlist = async () => {
    try {
      await deleteWishlistItem(isWishlistClicked._id, dispatch);
      dispatch(removeFromWishlist({ id: isWishlistClicked._id }));
      setIsWishlistClicked(null);
    } catch (error) {
      console.error("Failed to delete wishlist item:", error);
    }
  };

  const onBidClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (
      userType === "trader" &&
      (typeOfCredit === "retireable" || typeOfCredit === "non-transferable")
    ) {
      setNotificationDialogState(true);
    } else {
      bidHandler(`/bid?projectId=${projectId}&userId=${userId}`);
    }
  };

  const onInquireClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    InquireHandler();
  };

   
const handleVerifyClick = (e) => {
  e.preventDefault();
  e.stopPropagation();

  const signature =
    blockchain_detail?.transaction_signature ||
    projectBlockchainDetail?.[0]?.transaction_signature;

  if (signature) {
    window.open(
      `https://explorer.solana.com/tx/${signature}?cluster=mainnet-beta`,
      "_blank",
      "noopener,noreferrer"
    );
  } else {
    toast.error("BlockChain Details Not Found");
  }
};

  return (
    <div className="w-fit">
      <div className="w-[322px] py-3 px-2">
        <Link
          to={`/project-details?projectId=${projectId}&userId=${userId}&inquire=${!isListed}`}
          className="w-full p-1 rounded-lg h-76 shadow-custom bg-white block"
        >
          <div
            style={{ backgroundImage: `url(${cover_image})` }}
            className="w-full rounded-lg h-[140px] bg-cover relative"
            alt="project image"
          >
            <div className=" left-0 top-0 absolute w-9">
              {tokenType === "Gold" && (
                <img src="images/GoldTokens.png" alt="Gold Token" />
              )}
              {tokenType === "Silver" && (
                <img src="images/SilverTokens.png" alt="Silver Token" />
              )}
              {tokenType === "Bronze" && (
                <img src="images/BronzeTokens.png" alt="Bronze Token" />
              )}
            </div>
            <div
              className="absolute top-[0px] right-[0px] w-28  bg-white h-4 rounded-bl-md text-[8px] flex gap-1"
              onClick={handleVerifyClick}
            >
              <p className=" text-blue-800 font-bold pl-2">
                Verify on BlockChain
              </p>
              <svg
                class="h-3 w-3 text-blue-800"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                {" "}
                <path stroke="none" d="M0 0h24v24H0z" />{" "}
                <line x1="17" y1="7" x2="7" y2="17" />{" "}
                <polyline points="8 7 17 7 17 16" />
              </svg>
            </div>
            <div className="flex w-fit gap-1 absolute right-2 bottom-2">
              <img src="/images/SDG1.jpg" alt="" className="w-3 h-3" />
              <img src="/images/SDG2.jpg" alt="" className="w-3 h-3" />
            </div>
          </div>
          <div className="flex justify-between mx-2 mt-1">
            <div className="flex gap-1">
              <svg
                fill="#000000"
                width="10px"
                height="10px"
                viewBox="0 0 24 24"
                baseProfile="tiny"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17.657 5.304c-3.124-3.073-8.189-3.073-11.313 0-3.124 3.074-3.124 8.057 0 11.13l5.656 5.565 5.657-5.565c3.124-3.073 3.124-8.056 0-11.13zm-5.657 8.195c-.668 0-1.295-.26-1.768-.732-.975-.975-.975-2.561 0-3.536.472-.472 1.1-.732 1.768-.732s1.296.26 1.768.732c.975.975.975 2.562 0 3.536-.472.472-1.1.732-1.768.732z" />
              </svg>
              <span className="text-[8px] font-light text-[#252525]">
                {`${state}, ${country}`}
              </span>
            </div>
            <div className="flex">
              <span className="text-[8px] pr-1 font-light text-blue-800 leading-4">
                {categoryName}
              </span>
              {!isWishlistClicked ? (
                <img
                  src="images/wishlist.svg"
                  alt="wishlist-icon"
                  onClick={handleWishlistClick}
                />
              ) : (
                <img
                  src="images/checkedWishlist.svg"
                  alt="checked-wishlist-icon"
                  onClick={handleWishlistClick}
                />
              )}
            </div>
          </div>
          <div className="ml-1 mr-2">
            <div className="flex justify-between items-center">
              <h4 className="text-xl font-bold w-[75%] truncate">
                {projectName}
              </h4>

              <span className="text-[8px] font-medium text-blue-800 leading-4">
                OG Score - {ogScore}
              </span>
            </div>
            {isListed ? (
              <div className="flex mt-2">
                <div className="text-[8px] font-bold text-[#000] opacity-60 leading-4">
                  Listed Credits - {no_of_credits_to_sell}&nbsp;
                </div>
                <div className="text-[8px] font-bold text-[#252525] opacity-60 leading-4">
                  &nbsp; | &nbsp; Total Credits - {numberOfCredits}
                </div>
              </div>
            ) : (
              <div className="text-[8px] font-bold text-[#252525] opacity-60 leading-4">
                Total Credits - {numberOfCredits}
              </div>
            )}

            <div className="flex justify-between items-center font-medium text-base">
              <div className="flex">
                <div className="text-[8px] font-bold text-[#000] opacity-60 leading-4 capitalize">
                  {credit_transaction}&nbsp;
                </div>
                <div className="text-[8px] font-bold text-[#252525] opacity-60 leading-4 capitalize">
                  &nbsp;| &nbsp; {typeOfCredit}
                </div>
              </div>
              {isListed ? (
                <div>${price_per_credit}/Credits</div>
              ) : (
                <span className="text-[10px] text-blue-800 font-medium">
                  This Project is not Listed
                </span>
              )}
            </div>
            <div className="flex justify-between mt-1">
              <div className="w-14 flex items-center h-14">
                <img className="" src={localRegistryImage} alt={"registry"} />
              </div>
              {isListed ? (
                <div>
                  {actionButton && (
                    <span className="ml-4">
                      <Button
                        varient="primary"
                        borderColor="blue"
                        className="px-10 py-2 text-sm text-white bg-blue-800"
                        onClick={onBidClick}
                      >
                        Bid
                      </Button>
                    </span>
                  )}
                </div>
              ) : (
                <h3 className="text-xl mt-2 font-medium flex items-center">
                  <>
                    {actionButton && (
                      <div className="ml-4">
                        <Button
                          onClick={onInquireClick}
                          varient="primary"
                          borderColor="none"
                          className="px-7 py-2 text-sm text-blue-800 bg-blue-300 "
                        >
                          Inquire
                        </Button>
                      </div>
                    )}
                  </>
                </h3>
              )}
            </div>
          </div>
        </Link>
        <NotificationDialog
          open={notificationDialogState}
          onCancel={() => setNotificationDialogState(false)}
        />
      </div>
    </div>
  );
};

export default Index;
